import React, {Component} from 'react';

class LineItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      variantImage: '',
    };
  }

  componentWillMount() {
    this.setState({
      variantImage: localStorage.getItem(this.props.line_item.variant.id),
    });
  }

  decrementQuantity = (lineItemId) => {
    const updatedQuantity = this.props.line_item.quantity - 1;
    this.props.updateQuantityInCart(lineItemId, updatedQuantity);
  }

  incrementQuantity = (lineItemId) => {
    const updatedQuantity = this.props.line_item.quantity + 1;
    this.props.updateQuantityInCart(lineItemId, updatedQuantity);
  }

  render() {
    return (
      <li className="Line-item">
        <div className="Line-item__img">
          {this.state.variantImage ? (
            <img
              src={this.state.variantImage}
              alt={`${this.props.line_item.title} product shot`}
            />
          ) : null}
        </div>
        <div className="Line-item__content">
          <div className="Line-item__content-row">
            <div className="Line-item__variant-title">
              {this.props.line_item.variant.title}
            </div>
            <span className="Line-item__title">
              {this.props.line_item.title}
            </span>
          </div>
          <div className="Line-item__content-row">
            <div className="Line-item__quantity-container">
              <button
                id="quantity_dec"
                className="Line-item__quantity-update"
                onClick={() => this.decrementQuantity(this.props.line_item.id)}>
                -
              </button>
              <span className="Line-item__quantity">
                {this.props.line_item.quantity}
              </span>
              <button
                id="quantity_inc"
                className="Line-item__quantity-update"
                onClick={() => this.incrementQuantity(this.props.line_item.id)}>
                +
              </button>
            </div>
            <span
              className="Line-item__price"
              style={{color: this.props.style.theme}}>
              ${' '}
              {(
                this.props.line_item.quantity *
                this.props.line_item.variant.price
              ).toFixed(2)}
            </span>
          </div>
        </div>
      </li>
    );
  }
}

export default LineItem;



// WEBPACK FOOTER //
// ./src/components/LineItem.js